﻿import { AIAutomatedJeDashboardElement, AutomatedJeDashboardElement } from "./AutomatedJeDashboard.requests";

export const sortedBySubmittedTime = (
  items: AutomatedJeDashboardElement[]
): AutomatedJeDashboardElement[] | AIAutomatedJeDashboardElement[] => {
  return items.slice().sort((a, b) => {
    const da = new Date(a.submittedTime),
      db = new Date(b.submittedTime);
    return db > da ? 1 : db < da ? -1 : 0;
  });
};
